// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'
import ECharts from 'vue-echarts/components/ECharts'
import { formatDate } from './helpers/formatters'
import 'vuetify/dist/vuetify.min.css'
import 'babel-polyfill'
import VueMasonry from 'vue-masonry-css'
import VueCookie from 'vue-cookie'
import axios from 'axios'
import underscore from 'underscore'

window.Vue = Vue
Vue.component('chart', ECharts)
Vue.use(Vuetify)
Vue.use(Vuelidate)
Vue.use(VueMasonry)
Vue.use(VueCookie)
Vue.filter('date', formatDate)
Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {
  let isLoggedIn = store.getters['auth/isLoggedIn']
  let queryObject = Object.assign({}, to.query, from.query)

  if (!isLoggedIn) {
    console.log('ykx-v2-cookie-jwt-token: ' + Vue.cookie.get('ykx-v2-cookie-jwt-token'))
    if (Vue.cookie.get('ykx-v2-cookie-jwt-token') && Vue.cookie.get('ykx-v2-cookie-jwt-token').length > 0 && Vue.cookie.get('ykx-v2-cookie-jwt-user')) {
      store.commit('auth/setUser', JSON.parse(Vue.cookie.get('ykx-v2-cookie-jwt-user')))
      store.commit('auth/setToken', Vue.cookie.get('ykx-v2-cookie-jwt-token'))
      isLoggedIn = store.getters['auth/isLoggedIn']
    }
  }

  if (to.path !== '/login' && to.path !== '/demo') {
    if (isLoggedIn) {
      next({ query: queryObject })
    } else {
      if (to.fullPath !== '/') {
        queryObject.redirect = to.path
        next({ path: '/login', query: queryObject })
      } else {
        next({ path: '/login', query: queryObject })
      }
    }
  } else if (to.path === '/demo') {
    try {
      await store.dispatch('auth/login', { email: 'demo@yakshof.com', password: 'password' })
      next({ path: '/home', query: queryObject })
    } catch (e) {
      next({ path: '/login', query: queryObject })
    }
  } else {
    next({ query: queryObject })
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    this.$vuetify.theme.primary = '#f8a135'
    this.$vuetify.theme.secondary = '#EEEEEE'
    this.$vuetify.theme.accent = '#424242'
    this.$vuetify.theme.error = '#D50000'
  },
  mounted () {
    try {
      const isLoggedIn = store.getters['auth/isLoggedIn']
      if (isLoggedIn) {
        const currentUser = store.getters['auth/currentUser']
        if (currentUser.uuid && currentUser.uuid.length > 0) {
          return
        }
        axios.all([store.dispatch('getUserById', currentUser.id)]).then(axios.spread((response) => {
          if (response.data.status === 'SUCCESS') {
            if (response.data.payload.projects && response.data.payload.projects.length > 0) {
              var userProjects = response.data.payload.projects.slice()
              userProjects.sort(function (a, b) {
                var textA = a.name.toUpperCase()
                var textB = b.name.toUpperCase()
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
              })
              response.data.payload.projects = userProjects
            }
            if (!underscore.isEqual(currentUser, response.data.payload)) {
              this.$store.commit('auth/resetToken')
              this.$store.commit('auth/resetUser')
              this.$router.push('/login')
              this.$store.commit('notification/notify', {message: 'Your user has been changed, please login again.', show: true})
            }
          }
        })).catch((err) => {
          this.$store.commit('auth/resetToken')
          this.$store.commit('auth/resetUser')
          this.$router.push('/login')
          this.$store.commit('notification/notify', {message: 'Something went wrong, please login again.', show: true})
          console.log(err)
        })
      }
    } catch (err) {
      this.$store.commit('auth/resetToken')
      this.$store.commit('auth/resetUser')
      this.$router.push('/login')
      console.log(err)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js